export default "__VITE_ASSET__BrrJjy3___"